// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___WKzXG","errorText":"styles__errorText___E5kHm"};